export const BOND_TYPES = {
  NO_BOND: 'S',
};
